// The audit-selection step's table: one page of active OpsAudits with their
// work-step counts. Pagination lives in the page's TablePaginationBar.
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../components/ui/table";
import { OptroOpsAuditSummary } from "../../../../../models/audit/workStep";
import { SelectOpsAuditRow } from "./SelectOpsAuditRow";

interface SelectOpsAuditsTableProps {
  opsAudits: OptroOpsAuditSummary[];
  isSelected: (id: number) => boolean;
  onToggle: (audit: OptroOpsAuditSummary) => void;
}

export const SelectOpsAuditsTable = ({
  opsAudits,
  isSelected,
  onToggle,
}: SelectOpsAuditsTableProps) => {
  if (opsAudits.length === 0) {
    return (
      <div className="py-16 text-center text-sm text-stone-500">
        No active OpsAudits match your search.
      </div>
    );
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-10" />
          <TableHead>Audit</TableHead>
          <TableHead>Category</TableHead>
          <TableHead>Period</TableHead>
          <TableHead>Audit Lead</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Work Steps</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {opsAudits.map((audit) => (
          <SelectOpsAuditRow
            key={audit.id}
            audit={audit}
            checked={isSelected(audit.id)}
            onToggle={onToggle}
          />
        ))}
      </TableBody>
    </Table>
  );
};
